// extracted by mini-css-extract-plugin
export default {"icon":"icon--aDUu4J7M"};